export default __webpack_public_path__ + "static/media/legMarina.6f0bc0ab.png";